import { Play } from 'lucide-react';
import Reveal from './Reveal';
import { TESTIMONIAL_SLOTS } from '@/config/site';

function Corner({ className }) {
  return <span className={`absolute h-4 w-4 border-gold/70 ${className}`} />;
}

export default function Testimonials() {
  return (
    <section id="testimonios" data-testid="testimonials-section" className="border-t border-white/5 bg-noir px-5 py-24 sm:px-10 sm:py-32">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-[10px] uppercase tracking-[0.45em] text-gold">
            <span className="h-px w-8 bg-gold/60" /> Testimonios
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-display text-4xl uppercase leading-[1.02] text-cream sm:text-6xl" data-testid="testimonials-headline">
            La gente que <span className="italic text-silver">trabaja conmigo.</span>
          </h2>
        </Reveal>
        <div
          className="mt-12 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-4 sm:grid sm:grid-cols-3 sm:overflow-visible"
          data-testid="testimonials-track"
        >
          {TESTIMONIAL_SLOTS.map((t, i) => (
            <div
              key={t.id}
              data-testid={`testimonial-slot-${i + 1}`}
              className="relative m-2 aspect-[9/16] w-[70vw] max-w-[300px] shrink-0 snap-center border border-white/10 bg-obsidian sm:m-0 sm:w-auto"
            >
              <Corner className="left-0 top-0 border-l border-t" />
              <Corner className="right-0 top-0 border-r border-t" />
              <Corner className="bottom-0 left-0 border-b border-l" />
              <Corner className="bottom-0 right-0 border-b border-r" />
              <div className="absolute inset-0 m-2 flex flex-col items-center justify-center gap-5 bg-gradient-to-b from-charcoal via-obsidian to-noir text-center">
                <span data-testid={`testimonial-play-${i + 1}`} className="flex h-14 w-14 items-center justify-center rounded-full border border-gold/40 text-gold/80">
                  <Play size={16} className="ml-0.5" fill="currentColor" />
                </span>
                <div>
                  <p className="text-[9px] uppercase tracking-[0.4em] text-cream/70">Testimonio en video</p>
                  <p className="mt-2 text-[8px] uppercase tracking-[0.3em] text-gold/70">Próximamente</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-6 text-[10px] uppercase tracking-[0.3em] text-cream/40" data-testid="testimonials-note">
            Espacio reservado para los testimonios de quienes ya trabajan con Cristian
          </p>
        </Reveal>
      </div>
    </section>
  );
}
